import React from "react";
import "../inputs/input/Input.scss";
import PropTypes from "prop-types";

const Label = (props) => {
  return (
    <div className={`"d-flex align-items-center input-label-title mb-2" ${props.isLabelRightAligned ? "label-right-title" : ""}`}>
      {props.labelName && props.labelName !== "" ? (
        <label className="input-label">{props.labelName}
          {props.labelName.length > 0 && props.isRequired && <span className="validation-star">*</span>}
        </label>
      ) : null}
    </div>
  );
};

export default Label;

Label.propTypes = {
  labelName: PropTypes.string,
  isLabelRightAligned: PropTypes.bool,
  isRequired: PropTypes.bool,
};
